import Vue from 'vue'
import VueMaterial from 'vue-material'
import axios from 'axios'
import VueAxios from 'vue-axios'
import 'vue-material/dist/vue-material.min.css'
import 'vue-material/dist/theme/default.css'
import App from './App.vue'
import router from './router'
import store from './store'
import './quasar'
import './services/APIService'
import LazyYoutube from "vue-lazytube";
import ActivityIndicator from 'vue-activity-indicator'

Vue.config.productionTip = false

Vue.use(ActivityIndicator, VueMaterial)
Vue.use(VueAxios, axios)
Vue.use(LazyYoutube);
axios.interceptors.request.use((config) => {
    const token = store.state.jwtToken
    if(token) {
        config.headers.Authorization =`Bearer ${ token }`
    }
    return config
})
axios.interceptors.response.use((response) => {
    return response
}, (error) => {
    // Notify.create(`Errror: ${error}`);
    if(error.response.status === 403) {
        store.commit('updateJwtToken', '')
        const config = error.config
        if(!config._retry) {
            config._retry = true
            delete config.headers.Authorization
            return axios.request(config)
        }
    }

    if(axios.isCancel(error)) {
        console.log("Request Canceled");
        return
    }
    return Promise.reject(error)
})

store.commit('initStore')

router.beforeEach((to, from, next) => {
    next()
})

import Vuetify from 'vuetify'
Vue.use(Vuetify)
const opts = {    theme: {
        themes: {
            light: {
                primary: "#dddddd",
                secondary: "#ffcb5c",
                warning: "#ffc260",
            },
            dark: {
            },
        },
    },}
const vuetify= new Vuetify(opts)

fetch("/ext/config.json")
    .then((response) => response.json())
    .then((config) => {
        window.$config = config
        new Vue({
            vuetify,
            router,
            store,
            beforeCreate() {
            },
            created() {

            },
            render: h => h(App),
}).$mount('#app')
    })
